import { useEffect } from 'react';
import apis from './apis';
import useRequest from '../../utils/request';
import useStore from './store';

export default (function (lineId) {
  let params = JSON.parse(JSON.stringify(apis.getLineList));
  if (lineId) params.url += `?line_id=${lineId}`;
  const [, dispatch] = useStore();
  const { data } = useRequest(params);

  useEffect(() => {
    if (data !== null) dispatch.setList(data);
  }, [data, dispatch]);

  return data || [];
});
